import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { List, AutoSizer } from 'react-virtualized'
import Quote from './Quote'

const QuotesListItems = (props) => {
  const { results, selectQuote, closeModal } = props

  const rowRenderer = ({ key, index, style }) => {
    return (
      <Quote
        key={key}
        style={style}
        onClick={selectQuote(results[index], closeModal)}
        {...results[index]}
      />
    )
  }

  return (
    <div className="quotes-list-modal-content">
      {results && (
        <AutoSizer>
          {({ width }) => (
            <List
              width={width}
              height={500}
              rowCount={results.length}
              rowHeight={30}
              rowRenderer={rowRenderer}
              scrollToAlignment="start"
            />
          )}
        </AutoSizer>
      )}
      {!results && (
        <Typography align="center" color="error">
          Could not load quotes.
        </Typography>
      )}
    </div>
  )
}

QuotesListItems.propTypes = {
  results: PropTypes.array.isRequired,
  selectQuote: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default QuotesListItems



// WEBPACK FOOTER //
// ./src/cms/widgets/QuotePicker/QuotesListItems.js